import { PAGE_CACHE_HEADERS } from "@/lib/ssrCache";
import { ensureExists } from "@/lib/ensureExists";
import { createFileRoute } from "@tanstack/react-router";
import GenericProduct from "@/pages/GenericProduct";
import { redirectIfPruned } from "@/lib/prunedRedirect";

export const Route = createFileRoute("/air-compressors/$slug")({
  beforeLoad: async ({ params }) => {
    await redirectIfPruned("air-compressors", params.slug);
    await ensureExists("products", params.slug, { product_type: "air-compressors" });
  },
  component: () => <GenericProduct hubSlug="air-compressors" />,
  headers: () => PAGE_CACHE_HEADERS,
  head: ({ params }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/air-compressors/${params.slug}`;
    return {
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
});
